module.exports = "/assets/site/images/poligonright.png?1780fbb3b995daed0c76e75265581e3a";